module.exports = __webpack_public_path__ + "img/D201801_1.57ebc274.jpg";